import { __extends } from "tslib";
import { AsyncDataSource } from './AsyncDataSource';
import { EnumHelper } from '../Model/EnumHelper';
var StaticDataSource = /** @class */ (function (_super) {
    __extends(StaticDataSource, _super);
    function StaticDataSource(staticData) {
        return _super.call(this, staticData) || this;
    }
    StaticDataSource.fromEnum = function (enumObject) {
        return new StaticDataSource(EnumHelper.asList(enumObject));
    };
    StaticDataSource.prototype.getDataAsync = function () {
        return Promise.resolve(this.data);
    };
    Object.defineProperty(StaticDataSource.prototype, "willLoad", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    return StaticDataSource;
}(AsyncDataSource));
export { StaticDataSource };
